import { render, staticRenderFns } from "./DoctorStatistics.vue?vue&type=template&id=38cdf072&scoped=true"
import script from "./DoctorStatistics.vue?vue&type=script&lang=js"
export * from "./DoctorStatistics.vue?vue&type=script&lang=js"
import style0 from "./DoctorStatistics.vue?vue&type=style&index=0&id=38cdf072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cdf072",
  null
  
)

export default component.exports